import { jwtDecode } from 'jwt-decode';
import Envs from '@agoras/envs';
import Source from './Source.esm.js';
import { BearerType } from '../httpClient/auth.esm.js';

function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var LeadsAPI = /*#__PURE__*/ function(Source) {
    _inherits(LeadsAPI, Source);
    var _super = _create_super(LeadsAPI);
    function LeadsAPI(httpClient) {
        _class_call_check(this, LeadsAPI);
        var _this;
        _this = _super.call(this, {
            httpClient: httpClient,
            baseUrl: Envs.getConfig().marketplaceLeadsUrl
        });
        _define_property(_assert_this_initialized(_this), "version", '2022-07-01');
        return _this;
    }
    _create_class(LeadsAPI, [
        {
            key: "extractClaims",
            value: function extractClaims(jwt) {
                if (!jwt) {
                    throw new Error('Missing JWT in Authorization Header');
                }
                try {
                    var claims = jwtDecode(jwt);
                    return claims;
                } catch (e) {
                    throw new Error('Error decoding JWT');
                }
            }
        },
        {
            key: "me",
            value: function me() {
                var _this = this;
                return _async_to_generator(function() {
                    var _config_headers_Authorization_replace, _config_headers_Authorization, _config_headers, searchParams, response, data, config, profile, jwt, _this_extractClaims, puid, upn, name, tid, given_name, family_name, displayName, _profile_email, _profile_firstName, _profile_lastName, user;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                searchParams = new URLSearchParams({
                                    'api-version': _this.version
                                });
                                return [
                                    4,
                                    _this._httpClient.get('/api/me', {
                                        params: searchParams,
                                        baseURL: _this._baseUrl,
                                        headers: {
                                            'x-ms-source': 'AppSource',
                                            rawAuthorization: BearerType.LEADS
                                        }
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                data = response.data, config = response.config;
                                profile = data.profile;
                                jwt = (_config_headers = config.headers) === null || _config_headers === void 0 ? void 0 : (_config_headers_Authorization = _config_headers.Authorization) === null || _config_headers_Authorization === void 0 ? void 0 : (_config_headers_Authorization_replace = _config_headers_Authorization.replace) === null || _config_headers_Authorization_replace === void 0 ? void 0 : _config_headers_Authorization_replace.call(_config_headers_Authorization, 'Bearer ', '');
                                _this_extractClaims = _this.extractClaims(jwt), puid = _this_extractClaims.puid, upn = _this_extractClaims.upn, name = _this_extractClaims.name, tid = _this_extractClaims.tid, given_name = _this_extractClaims.given_name, family_name = _this_extractClaims.family_name;
                                displayName = profile.firstName && profile.lastName ? "".concat(profile.firstName, " ").concat(profile.lastName) : name;
                                user = {
                                    id: puid,
                                    tid: tid,
                                    displayName: displayName,
                                    email: (_profile_email = profile.email) !== null && _profile_email !== void 0 ? _profile_email : upn,
                                    firstName: (_profile_firstName = profile.firstName) !== null && _profile_firstName !== void 0 ? _profile_firstName : given_name,
                                    lastName: (_profile_lastName = profile.lastName) !== null && _profile_lastName !== void 0 ? _profile_lastName : family_name
                                };
                                return [
                                    2,
                                    user
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return LeadsAPI;
}(Source);

export { LeadsAPI };
